import React from 'react';
import { motion } from 'framer-motion';

const CompletionStep = ({ onSubmit, selectedAvatar, formData }) => {
  return (
    <div className="max-w-2xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <div className="text-center">
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ 
              type: "spring", 
              stiffness: 260, 
              damping: 20,
              delay: 0.2
            }}
            className="w-24 h-24 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-6"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </motion.div>
          
          <h1 className="text-3xl font-bold mb-2">You're All Set! 🎉</h1>
          <p className="text-gray-600 mb-8">
            Your profile is ready to help you find your dream job
          </p>
        </div>
        
        {/* Profile summary */}
        <div className="bg-white rounded-lg border border-gray-200 p-6 mb-8">
          <div className="flex items-center mb-6">
            <div className="mr-4">
              {selectedAvatar ? (
                <img src={selectedAvatar} alt="Avatar" className="w-16 h-16 rounded-full" />
              ) : (
                <div className="w-16 h-16 rounded-full bg-gray-200 flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                </div>
              )}
            </div>
            <div>
              <h2 className="text-xl font-bold">{formData.basicInfo.name || 'Your Name'}</h2>
              <p className="text-gray-600">{formData.basicInfo.location || 'Your Location'}</p>
            </div>
          </div>
          
          <div className="space-y-4">
            <div>
              <h3 className="text-sm font-medium text-gray-500">Contact Information</h3>
              <p className="text-gray-800">{formData.basicInfo.email || 'email@example.com'}</p>
              <p className="text-gray-800">{formData.basicInfo.phone || 'Phone number'}</p>
            </div>
            
            <div>
              <h3 className="text-sm font-medium text-gray-500">Skills</h3>
              <div className="flex flex-wrap gap-2 mt-1">
                {formData.skills && formData.skills.length > 0 ? (
                  formData.skills.map((skill, index) => (
                    <span key={index} className="bg-gray-100 text-gray-800 text-xs px-2 py-1 rounded">
                      {typeof skill === 'string' ? skill : skill.name}
                    </span>
                  ))
                ) : (
                  <span className="text-gray-400">No skills added yet</span>
                )}
              </div>
            </div>
          </div>
        </div>
        
        {/* Next steps */}
        <div className="bg-blue-50 border border-blue-100 rounded-lg p-6 mb-8">
          <h3 className="text-lg font-medium text-blue-800 mb-4">Next Steps</h3>
          <ul className="space-y-3">
            <li className="flex items-start">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500 mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
              <span>Browse job listings that match your skills and preferences</span>
            </li>
            <li className="flex items-start">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500 mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
              <span>Set up job alerts to get notified about new opportunities</span>
            </li>
            <li className="flex items-start">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500 mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
              <span>Complete any missing profile sections to improve visibility</span>
            </li>
          </ul>
        </div>
        
        {/* Submit button */}
        <div className="text-center">
          <motion.button
            type="button"
            className="px-8 py-3 bg-black text-white font-bold rounded-md shadow-lg hover:bg-gray-800 transition-all"
            onClick={onSubmit}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Go to Dashboard
          </motion.button>
        </div>
      </motion.div>
    </div>
  );
};

export default CompletionStep;
